import React, { useEffect, useState } from 'react';
import { colors, FONT } from '../../../../theme';
import { S } from '../../dashboardStyles';
import { SS } from '../settingsStyles';
import SettingsScreen from '../SettingsScreen';
import { api } from '../../../../services/api';

const ACTIONS = {
  create: 'завёл', disable: 'заблокировал', enable: 'разблокировал',
  role: 'сменил роль', reset_password: 'сбросил пароль', delete: 'удалил', note: 'изменил заметку',
};

/**
 * What administrators did, and to whom.
 *
 * Names are stored as text rather than ids on purpose: the record has to
 * survive the deletion of the person it is about, and deletion is exactly the
 * entry somebody will come looking for.
 */
export default function AdminAuditScreen({ onBack }) {
  const [items, setItems] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [error, setError] = useState('');

  const load = async (next = null) => {
    try {
      const r = await api.adminAudit({ limit: 50, ...(next ? { cursor: next } : {}) });
      setItems(prev => (next ? [...prev, ...(r.items || [])] : (r.items || [])));
      setCursor(r.next_cursor || null);
    } catch (e) { setError(e.message || 'Не удалось загрузить'); }
  };

  useEffect(() => { load(); }, []); // eslint-disable-line

  return (
    <SettingsScreen title="Журнал действий" onBack={onBack} scrollKey="admin-audit">
      {error && <div style={{ ...SS.consequence, color: colors.red, padding: '0 16px 8px' }}>{error}</div>}
      <div style={S.settingsCard}>
        {items.length === 0 && !error && (
          <div style={{ ...SS.consequence, padding: 16 }}>Пока ничего не делали</div>
        )}
        {items.map((r, i) => (
          <div key={r.id} style={{
            padding: '12px 16px', fontFamily: FONT,
            borderBottom: i < items.length - 1 ? `1px solid ${colors.gray100}` : 'none',
          }}>
            <div style={{ fontSize: 14.5, color: colors.gray900 }}>
              <b>{r.actor_username}</b> {ACTIONS[r.action] || r.action}
              {r.target_username ? <> <b>{r.target_username}</b></> : null}
            </div>
            <div style={SS.consequence}>
              {new Date(String(r.created_at).replace(' ', 'T') + 'Z')
                .toLocaleString('ru-RU', { day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' })}
            </div>
          </div>
        ))}
      </div>
      {cursor && (
        <button onClick={() => load(cursor)} style={{ ...S.textBtn, width: '100%', minHeight: 48, marginTop: 8 }}>
          Показать ещё
        </button>
      )}
    </SettingsScreen>
  );
}
